import { Div } from "../../../../../base/components/native/div"
import { Img } from "../../../../../base/components/native/img"
import { Input } from "../../../../../base/components/native/input"
import { HIDE, SHOW } from "../../../../../base/helpers/style"
import { IMAGES } from "../../../../../configs/images"
import { baseStyle, inputStyle, linkStyle, titleStyle } from "./url-input.style"

export const UrlInput = (value: string) => {

    const base = Div()
    base.cssClass(baseStyle)

    const title = Div('آدرس صفحه')
    title.cssClass(titleStyle)
    base.append(title)

    const link = Img(IMAGES.ICONS.LINK, { width: 18 })
    link.el.onclick = () => {
        window.open(input.getValue(), '_blank')
    }
    link.cssClass(linkStyle)
    // if (!value) link.style(HIDE)
    base.append(link)

    const input = Input('https://daneshfx.com/fa/articles/', 'text')
    input.cssClass(inputStyle)
    input.setValue(value || 'https://daneshfx.com/fa/articles/')
    base.append(input)

    input.on('input', () => {
        if (input.getValue().includes('http')) {
            link.style(SHOW)
        } else {
            link.style(HIDE)
        }
    })

    return Object.assign(base, {
        getValue: () => input.getValue(),
        setValue: (value: string) => {
            input.setValue(value) // todo fix oninput listener
            if (value) link.style(SHOW)
            else link.style(HIDE)
        }
    })

}